<template>
    <div class="component-wrap">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex lg6>
                        <h1 class="section-title-main my-3 mr-4 font-weight-regular">{{$t("Мои мероприятия")}}</h1>
                    </v-flex>
                    <v-flex lg6>
                        <inputIcon v-model="events_search" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>

                </v-layout>
                <v-layout column mb-4>
                    <v-tabs
                        v-model="tabs"
                        slot="extension"
                        color="white"
                        :slider-color="tabsColor"
                        class="tabs-mobile"
                    >
                        <v-tab class="wrapper-relative" href="#accepted">
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         symbol="accept-oem"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >{{$t("Регистрация подтверждена")}}</v-flex>
                                <v-flex class="md1 study__badge">
                                    <v-badge color="#84a45d">
                                        <span slot="badge">3</span>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tab class="wrapper-relative" href="#processing" width="260px">
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         symbol="processing"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >{{$t("Обрабатывается")}}</v-flex>
                                <v-flex class="md1 study__badge">
                                    <v-badge color="#2755cf">
                                        <span slot="badge">3</span>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tab class="wrapper-relative" href="#declined">
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         symbol="declined"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >{{$t("Региcтрация отклонена")}}</v-flex>
                                <v-flex class="md1 study__badge pl-1">
                                    <v-badge color="#e2173d">
                                        <span slot="badge">3</span>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tab-item
                            id="accepted"
                            class="py-5"
                        >
                            <news v-for="(event, i) in paginated" :key="i" :content="event" />
                        </v-tab-item>
                        <v-tab-item
                            id="processing"
                            class="py-5"
                        >
                            <news v-for="(event, i) in paginated" :key="i" :content="event" />
                        </v-tab-item>
                        <v-tab-item
                            id="declined"
                            class="py-5"
                        >
                            <news v-for="(event, i) in paginated" :key="i" :content="event" />
                        </v-tab-item>
                    </v-tabs>
                    <div class="mb-4" :class="{'mx-3': $vuetify.breakpoint.xs}">
                        <buttonBdWhite @click.native="OPEN_MODAL('suggest_news_modal')">{{$t("Предложить мероприяти")}}е</buttonBdWhite>
                    </div>
                </v-layout>
            </v-layout>
            <v-dialog v-model="suggest_news_modal" persistent content-class="scrolled-dialog">
                <addNewsModal v-if="suggest_news_modal" :event_only="true" />
            </v-dialog>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import buttonBdWhite   from '@/components/ui/buttons/button_bd_white';
import news from '@/components/blocks/news/news_page_item';
import addNewsModal from '@/components/view_blocks/News_main/News_modals/modal_add_news';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonBdWhite,
    news,
    addNewsModal,
  },
  data() {
    return {
      panel: [],
      items: 5,
    };
  },
  computed: {
    ...mapGetters('news_main', [
      'suggest_news_modal',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('ideas_bank', [
      'ideas_bank_modal',
    ]),
    ...mapGetters('events', [
      'events',
      'paginated',
      'filtered_by_tab',
      'events_accepted',
      'events_processing',
      'events_declined',
      'search_string',
      'tab',
    ]),
    tabsColor() {
      if (this.tabs=='accepted') {
        return '#84a45d';
      } else if (this.tabs=='processing') {
        return '#2755cf';
      } else if (this.tabs=='declined') {
        return '#e2173d';
      }
    },
    events_search: {
      get() {
        return this.search_string;
      },
      set($event) {
        return this.SEARCH_STRING($event.target.value);
      },
    },
    tabs: {
      get() {
        return this.tab;
      },
      set($event) {
        return this.SET_ACTIVE_TAB($event);
      },
    },
  },
  async mounted() {
    await this.get_events();
  },
  methods: {
    ...mapMutations('news_main', [
      'OPEN_MODAL',
    ]),
    ...mapMutations('events', [
      'SEARCH_STRING',
      'SET_ACTIVE_TAB',
    ]),
    ...mapActions('events', [
      'get_events',
    ]),
  },
};
</script>
